// extracted by mini-css-extract-plugin
export default {"container":"kk-z","blurb":"lk-z","links":"mk-z"};